import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Providers } from './app/providers'
import { App } from './app/App'
import { syncDocumentLocale } from './config/locale'
import './styles/globals.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root element not found')

syncDocumentLocale()

createRoot(root).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
)
